var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1975 23.1628C19.1975 13.318 27.1783 5.33723 37.0231 5.33723C46.8679 5.33723 54.8487 13.318 54.8487 23.1628V27.4187C53.5804 27.4069 52.2288 27.407 50.7908 27.407L50.6045 27.407H23.4417L23.2554 27.407C21.8174 27.407 20.4658 27.4069 19.1975 27.4187V23.1628ZM14.1045 27.5861V23.1628C14.1045 10.5052 24.3655 0.244202 37.0231 0.244202C49.6807 0.244202 59.9417 10.5052 59.9417 23.1628V27.5862C60.7119 27.6403 61.4377 27.7108 62.1206 27.8026C65.1768 28.2135 67.75 29.0926 69.7938 31.1363C71.8375 33.1801 72.7166 35.7533 73.1275 38.8095C73.5232 41.7531 73.5232 45.4958 73.5231 50.139V50.1393V50.3256V50.512V50.5121C73.5232 55.1554 73.5232 58.8981 73.1275 61.8417C72.7166 64.8979 71.8375 67.4711 69.7938 69.5149C67.75 71.5586 65.1768 72.4377 62.1206 72.8486C59.177 73.2444 55.4342 73.2443 50.7908 73.2442H50.6045H23.4417H23.2553C18.6119 73.2443 14.8692 73.2444 11.9255 72.8486C8.8693 72.4377 6.29605 71.5586 4.25234 69.5148C2.20864 67.4711 1.32961 64.8979 0.918711 61.8417C0.522947 58.898 0.523003 55.1553 0.523073 50.5119L0.523075 50.3256L0.523073 50.1393C0.523003 45.4959 0.522947 41.7532 0.918711 38.8095C1.32961 35.7533 2.20864 33.1801 4.25234 31.1364C6.29605 29.0926 8.8693 28.2135 11.9255 27.8026C12.6084 27.7108 13.3343 27.6403 14.1045 27.5861ZM12.6041 32.8502C10.1127 33.1852 8.7934 33.7979 7.85369 34.7376C6.91396 35.6774 6.30128 36.9967 5.96632 39.4881C5.62151 42.0528 5.6161 45.4519 5.6161 50.3256C5.6161 55.1993 5.62151 58.5984 5.96632 61.1631C6.30128 63.6545 6.91396 64.9738 7.85369 65.9136C8.7934 66.8533 10.1127 67.466 12.6041 67.801C15.1688 68.1458 18.5679 68.1512 23.4417 68.1512H50.6045C55.4782 68.1512 58.8773 68.1458 61.4419 67.801C63.9333 67.466 65.2527 66.8533 66.1925 65.9136C67.1322 64.9738 67.7449 63.6544 68.0799 61.163C68.4247 58.5984 68.4301 55.1993 68.4301 50.3256C68.4301 45.4519 68.4247 42.0528 68.0799 39.4882C67.7449 36.9968 67.1322 35.6774 66.1925 34.7376C65.2527 33.7979 63.9333 33.1852 61.4419 32.8502C58.8773 32.5054 55.4782 32.5 50.6045 32.5H23.4417C18.5679 32.5 15.1688 32.5054 12.6041 32.8502ZM37.0232 40.9884C38.4296 40.9884 39.5697 42.1285 39.5697 43.5349V57.1163C39.5697 58.5227 38.4296 59.6628 37.0232 59.6628C35.6168 59.6628 34.4767 58.5227 34.4767 57.1163V43.5349C34.4767 42.1285 35.6168 40.9884 37.0232 40.9884Z",
    fill: "url(#paint0_linear_43649_29991)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_43649_29991",
    x1: 37.6601,
    y1: -10.2109,
    x2: 37.6601,
    y2: 79.3083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08538C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#6F5BA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F5648B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FF8A60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC038"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.3e456f5a49b2f426eb4caa160dcaee96.svg";
export { ForwardRef as ReactComponent };